import {Cheap} from '@esgi/ui';
import {styled} from '@esgi/ui/theme';

export const StyledCheap = styled(Cheap, {
	borderColor: '$surface',
});
